export default __webpack_public_path__ + "static/media/dot-plot-categories-blue.81adf8ad.svg";